var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "reveal boss-modal-container pega-modal-position",
      attrs: { id: "interview-place-register-modal", "data-reveal": "" },
    },
    [
      _c(
        "h1",
        {
          staticClass:
            "boss-page-title boss-page-title-layout-title pega-mb-25",
          attrs: { "data-test": "modal-title" },
        },
        [_vm._v("\n    面接場所を" + _vm._s(_vm.titleLabel) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout boss-layout-center" }, [
        _c("div", { staticClass: "pega-bulk-update-container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { attrs: { "data-test": "modal-body-display-address" } },
              [_vm._v("\n          表示用住所(100文字以内)\n        ")]
            ),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.displayAddress,
                    expression: "displayAddress",
                  },
                ],
                staticClass: "boss-input boss-input-fill",
                attrs: {
                  type: "text",
                  placeholder:
                    "例：サンプル港区赤坂本店（※URLは入力できません）",
                  "data-test": "display-address",
                },
                domProps: { value: _vm.displayAddress },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.displayAddress = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { "data-test": "modal-body-display-google-map-address" } },
            [_vm._v("\n        Googleマップ用住所(100文字以内)\n      ")]
          ),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.googleMapAddress,
                  expression: "googleMapAddress",
                },
              ],
              staticClass: "boss-input boss-input-fill",
              attrs: {
                type: "text",
                placeholder:
                  "例：東京都港区赤坂3-21-20ロングビーチビル（※URLは入力できません）",
                "data-test": "display-google-map-address",
              },
              domProps: { value: _vm.googleMapAddress },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.googleMapAddress = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "boss-button-center pega-button",
              attrs: {
                disabled: !_vm.googleMapAddress,
                type: "button",
                "data-test": "preview-button",
              },
              on: {
                click: function ($event) {
                  return _vm.previewOpen()
                },
              },
            },
            [_vm._v("\n        プレビュー\n      ")]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass:
                  "float-center boss-button-center boss-button-large pega-button pega-mr-20 pega-mt-15",
                attrs: {
                  disabled: !_vm.displayAddress,
                  type: "button",
                  "data-test": "register-button",
                },
                on: {
                  click: function ($event) {
                    return _vm.registerOrUpdate()
                  },
                },
              },
              [_vm._v("\n          " + _vm._s(_vm.actionLabel) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "float-center boss-button-center boss-button-large pega-mt-15",
                attrs: {
                  type: "button",
                  "data-close": "",
                  "aria-label": "Close modal",
                  "data-test": "cancel-button",
                },
                on: {
                  click: function ($event) {
                    return _vm.closeReveal()
                  },
                },
              },
              [_vm._v("\n          キャンセル\n        ")]
            ),
          ]),
          _vm._v(" "),
          !_vm.isInterviewInformation
            ? _c(
                "div",
                { attrs: { "data-test": "modal-body-display-interview-link" } },
                [
                  _vm._v("\n        登録した面接場所の編集・削除は"),
                  _c(
                    "a",
                    {
                      attrs: { "data-test": "interview" },
                      on: { click: _vm.goToInterviewInformation },
                    },
                    [_vm._v("こちら")]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "close-button boss-close-button boss-icon-cross",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
        on: {
          click: function ($event) {
            return _vm.closeReveal()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-color-red" }, [
      _vm._v("\n        webや電話による面接の場合、こちらではなく、"),
      _c("br"),
      _vm._v("\n        メッセージ本文にURLを記載してください。\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }